import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { SessionUserService } from './services/session-user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  constructor(
    private authService: AuthService,
    private session: SessionUserService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (
      event.shiftKey &&
      event.ctrlKey &&
      event.code === 'KeyU' &&
      environment.name === 'staging'
    ) {
      throw new Error('Fake Error caused by hotkeys');
    }
  }

  ngOnInit() {
    // Left behind when a rejected session was ended: the logout is a
    // full-page redirect, so this is the first chance to say why.
    const notice = this.authService.consumeAuthNotice();
    if (notice) {
      this.toastr.warning(notice, 'Signed out', { timeOut: 10000 });
    }

    const redirectUrl = this.authService.consumeRedirectedUrl();

    if (redirectUrl && this.session.authenticated) {
      this.router.navigateByUrl(redirectUrl);
    }
  }
}
